import React, { useEffect, useMemo, useState } from "react";
import DropdownSelect from "../common/DropdownSelect";
import { Link } from "react-router-dom";
import Pagination2 from "../common/Pagination2";
import { BaseURL, NewProperty } from "../../APIs/APIUrls";
import { useSnackbar } from "notistack";
import { GetEnquiryByVendorId } from "../../APIs/EnquiryAPI";
import avatarimg from "../../images/avatar/avatar.jpg";

export default function Dashboard() {
  const { enqueueSnackbar } = useSnackbar();
  const vendorid = localStorage.getItem("id") || 0;
  const [page, setPage] = useState(1);
  const [ItemsPerPage] = useState(10);
  const [SearchTerm, setSearchTerm] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const [myProperties, setMyProperties] = useState([]);
  const [myPropertiesFilter, setMyPropertiesFilter] = useState([]);
  const [enquiries, setEnquiries] = useState([]);

  const getToken = () => {
    try {
      const tokenStr = localStorage.getItem("tcn");
      return tokenStr ? JSON.parse(tokenStr) : null;
    } catch (error) {
      console.error("Error parsing token:", error);
      return localStorage.getItem("tcn");
    }
  };

  const isClosedPropertyStatus = (statusName) => {
    const normalizedStatus = String(statusName ?? "").trim().toLowerCase();
    return ["rented", "sold", "pg rented"].includes(normalizedStatus);
  };

  const getClosedPropertyStatus = (propertyForValue) => {
    if (propertyForValue === "Rent") {
      return "Rented";
    }

    if (propertyForValue === "Sell") {
      return "Sold";
    }

    if (propertyForValue === "PG") {
      return "PG Rented";
    }

    return "";
  };

  const fnGetMyProperties = async () => {
    try {
      //debugger;
      const userId = localStorage.getItem("id") || vendorid;
      const Token = getToken();
      if (!Token) {
        enqueueSnackbar('Authentication token not found. Please login again.', { variant: 'error' });
        return;
      }

      const response = await fetch(NewProperty + "GetNewPropertyByVendorId/" + userId, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
        body: JSON.stringify({}),
      });
      debugger;
      if (!response.ok) {
        if (response.status === 401) {
          enqueueSnackbar('Unauthorized: Your session has expired. Please login again.', { variant: 'error' });
          localStorage.clear();
          window.location.href = '/';
        }
        throw new Error(`Server error: ${response.status}`);
      }

      const text = await response.text();
      if (!text || text.trim() === "") {
        throw new Error("Server returned an empty response");
      }

      const result = JSON.parse(text);
      const list = Array.isArray(result?.data) ? result.data : [];
      setMyProperties(list);
      setMyPropertiesFilter(list);
    } catch (error) {
      console.error("Error fetching properties:", error);
      enqueueSnackbar("Error fetching properties. Please try again.", { variant: "error" });
    }
  };

  const fnGetMyEnquiries = async () => {
    try {
      const userId = localStorage.getItem("id") || vendorid;
      const token = getToken();

      if (!token) {
        return;
      }

      const response = await GetEnquiryByVendorId(userId, token);
      if (!response.success) {
        enqueueSnackbar(response.message || "Failed to load enquiries.", { variant: "warning" });
        setEnquiries([]);
        return;
      }

      const enquiryList = Array.isArray(response.data) ? response.data : [];
      const sortedByLatest = [...enquiryList].sort(
        (a, b) => new Date(b?.CreatedOn || 0) - new Date(a?.CreatedOn || 0)
      );
      setEnquiries(sortedByLatest);
    } catch (error) {
      console.error("Error fetching enquiries:", error);
      enqueueSnackbar("Error fetching enquiries. Please try again.", { variant: "error" });
      setEnquiries([]);
    }
  };

  useEffect(() => {
    fnGetMyProperties();
    fnGetMyEnquiries();
  }, []);

  useEffect(() => {
    const q = SearchTerm.trim().toLowerCase();
    const fromDateObj = fromDate ? new Date(fromDate) : null;
    const toDateObj = toDate ? new Date(toDate) : null;

    if (toDateObj) {
      toDateObj.setHours(23, 59, 59, 999);
    }

    const searchableFields = [
      "PropertyId",
      "VendorId",
      "PropertyGeneratedId",
      "GovtPropertyId",
      "PropertyTitle",
      "PropertyDescription",
      "Address",
      "City",
      "State",
      "PinCode",
      "Country",
      "EmbdedMapURL",
      "Latitude",
      "Longitude",
      "PropertyPrice",
      "YearBuilt",
      "VideoURL",
      "PropertyType",
      "PropertyStatus",
      "StatusName",
      "PropertyLabel",
      "BedRoomQty",
      "BathroomQty",
      "ConstructionStatus",
      "ConstructedArea",
      "LandArea",
      "Garages",
      "GaragesSize",
      "CarSpaceQty",
      "IsFeatured",
      "FeatureIndex",
      "PropertyFor",
      "PropertyTypeName",
      "ProjectTypeName",
      "PropertyLabelName",
      "IsPropertyImages",
      "IsWantFeatureProperty",
    ];

    const normalizeValue = (value) => {
      if (value === null || value === undefined) return "";
      if (typeof value === "boolean") return value ? "true yes 1" : "false no 0";
      return String(value).toLowerCase();
    };

    const filtered = myProperties.filter((item) => {
      const haystack = searchableFields
        .map((field) => normalizeValue(item?.[field]))
        .filter(Boolean)
        .join(" ");

      const createdOn = item?.CreatedOn ? new Date(item.CreatedOn) : null;
      const hasValidCreatedOn = createdOn && !Number.isNaN(createdOn.getTime());

      const passesFromDate = !fromDateObj || (hasValidCreatedOn && createdOn >= fromDateObj);
      const passesToDate = !toDateObj || (hasValidCreatedOn && createdOn <= toDateObj);
      const passesSearch = !q || haystack.includes(q);

      return passesSearch && passesFromDate && passesToDate;
    });

    setMyPropertiesFilter(filtered);
    setPage(1);
  }, [SearchTerm, fromDate, toDate, myProperties]);

  const pagedProperties = useMemo(() => {
    const start = (page - 1) * ItemsPerPage;
    return myPropertiesFilter.slice(start, start + ItemsPerPage);
  }, [myPropertiesFilter, page, ItemsPerPage]);

  const featuredPropertiesCount = useMemo(() => {
    return myProperties.filter((item) => {
      const value = item?.IsFeatured;
      return value === true || value === 1 || String(value).toLowerCase() === "true";
    }).length;
  }, [myProperties]);

  const salePropertiesCount = useMemo(() => {
    return myProperties.filter((item) => String(item?.PropertyFor || "").toLowerCase() === "sell").length;
  }, [myProperties]);

  const rentPropertiesCount = useMemo(() => {
    return myProperties.filter((item) => String(item?.PropertyFor || "").toLowerCase() === "rent").length;
  }, [myProperties]);

  const pgPropertiesCount = useMemo(() => {
    return myProperties.filter((item) => String(item?.PropertyFor || "").toLowerCase() === "pg").length;
  }, [myProperties]);

  const closedPropertiesCount = useMemo(() => {
    return myProperties.filter((item) => {
      const pf = String(item?.PropertyFor || "").toLowerCase();
      return pf === "sold" || pf === "rented" || pf === "pg rented";
    }).length;
  }, [myProperties]);

  const getDaysAgoLabel = (createdOn) => {
    if (!createdOn) return "-";

    const createdDate = new Date(createdOn);
    if (Number.isNaN(createdDate.getTime())) return "-";

    const now = new Date();
    const diffInMs = now.getTime() - createdDate.getTime();
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    if (diffInDays <= 0) return "Today";
    if (diffInDays === 1) return "1 day ago";
    return `${diffInDays} days ago`;
  };

  const getMessagePhoto = (enquiry) => {
    const photoPath = enquiry?.ClientPhoto || enquiry?.Photo || "";
    if (!photoPath) return "";
    if (photoPath.startsWith("http") || photoPath.startsWith("data:")) {
      return photoPath;
    }
    return `${BaseURL}${photoPath.startsWith("/") ? photoPath.slice(1) : photoPath}`;
  };

  const fallbackAvatars = [
    "/images/avatar/avt-png9.png",
    "/images/avatar/avt-png10.png",
    "/images/avatar/avt-png11.png",
    "/images/avatar/avt-png12.png",
  ];

  return (
    <div className="main-content">
      <div className="main-content-inner">
        <div className="button-show-hide show-mb">
          <span className="body-1">Show Dashboard</span>
        </div>
        <div className="flat-counter-v2 tf-counter">
          <div className="counter-box">
            <div className="box-icon">
              <span className="icon icon-listing" />
            </div>
            <div className="content-box">
              <div className="title-count text-variant-1">Listed Properties</div>
              <div className="box-count d-flex align-items-end">
                {/* <h3 className="number fw-8" data-speed="2000" data-to="17" data-inviewport="yes">32</h3>       */}
                <h3 className="fw-8">{myProperties.length}</h3>
                {/* <span className="text">Total Listed Properties</span> */}
              </div>
            </div>
          </div>
          <div className="counter-box">
            <div className="box-icon">
              <span className="icon icon-pending" />
            </div>
            <div className="content-box">
              <div className="title-count text-variant-1">Property for PG</div>
              <div className="box-count d-flex align-items-end">
                <h3 className="fw-8">{pgPropertiesCount}</h3>
              </div>
            </div>
          </div>
          <div className="counter-box">
            <div className="box-icon">
              <span className="icon icon-favorite" />
            </div>
            <div className="content-box">
              <div className="title-count text-variant-1">Properties for Sell</div>
              <div className="d-flex align-items-end">
                {/* <h6 className="number" data-speed="2000" data-to="1" data-inviewport="yes">1</h6>  */}
                <h3 className="fw-8">{salePropertiesCount}</h3>
              </div>
            </div>
          </div>
          <div className="counter-box">
            <div className="box-icon">
              <span className="icon icon-review" />
            </div>
            <div className="content-box">
              <div className="title-count text-variant-1">Properties for Rent</div>
              <div className="d-flex align-items-end">
                <h3 className="fw-8">{rentPropertiesCount}</h3>
              </div>
            </div>
          </div>
          <div className="counter-box">
            <div className="box-icon">
              <span className="icon icon-review" />
            </div>
            <div className="content-box">
              <div className="title-count text-variant-1">Closed Properties</div>
              <div className="box-count d-flex align-items-end">
                <h3 className="fw-8">{closedPropertiesCount}</h3>
              </div>
            </div>
          </div>
        </div>
        <div className="wrapper-content row">
          <div className="col-xl-9">
            <div className="widget-box-2 wd-listing">
              {/* <h5 className="title">New Listing</h5> */}
              <div className="wd-filter">
                <div className="ip-group icon-left">
                  <input
                    type="text"
                    placeholder="Search by Property ID, Title, Detail, Category, Status...."
                    value={SearchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <span className="icon icon-search" />
                </div>
                <div className="ip-group icon">
                  <input
                    type="date"
                    id="datepicker1"
                    className="ip-datepicker icon"
                    placeholder="From Date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                </div>
                <div className="ip-group icon">
                  <input
                    type="date"
                    id="datepicker2"
                    className="ip-datepicker icon"
                    placeholder="To Date"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                </div>
                {/* <div className="ip-group">
                  <DropdownSelect
                    defaultOption="Select"
                    options={["Today", "Yesterday"]}
                  />
                </div> */}
              </div>
              <div className="d-flex gap-4">
                <span className="text-primary fw-7">{myPropertiesFilter.length}</span>
                <span className="fw-6">Results found</span>
              </div>
              <div className="wrap-table">
                <div className="table-responsive">
                  <table className="ap2-properties-table">
                    <thead>
                      <tr>
                        <th style={{ width: "2%" }}>Sr No</th>

                        <th style={{ width: "45%" }}>Property Title & Detail</th>
                        <th style={{ width: "10%" }}>Property Images</th>
                        <th style={{ width: "10%" }}>Inside Facilities</th>
                        <th style={{ width: "10%" }}>Outer Facilities</th>
                        <th style={{ width: "10%" }}>Property Document</th>
                        <th style={{ width: "10%" }}>Property Floor</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        myPropertiesFilter.slice((page - 1) * ItemsPerPage, page * ItemsPerPage).map((propertyItem, index) => (
                          <tr className="file-delete" key={index}>
                            <td>
                              <span>{(page - 1) * ItemsPerPage + index + 1}</span>
                            </td>


                            <td>
                              <div className="listing-box">
                                <div className="content">
                                  <span style={{ fontWeight: "bolder", letterSpacing: "1px" }}>{propertyItem.PropertyGeneratedId} </span>

                                  <div className="title">
                                    <Link
                                      className="link"
                                    >
                                      {propertyItem.PropertyFor} : {propertyItem.PropertyTitle}
                                    </Link>
                                  </div>
                                  <span style={{ fontSize: "13px" }}>{`${propertyItem.BuildingTypeName} : ${propertyItem.PropertyTypeName}`}</span>
                                  <div className="text-date">
                                    Posted Date: {propertyItem.CreatedOn ? new Date(propertyItem.CreatedOn).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }) : ''}
                                  </div>
                                  <span style={{ fontWeight: "bolder", letterSpacing: "1px" }}>{propertyItem.StatusName}</span>

                                  {
                                    propertyItem.IsPropertyImages && (
                                      <Link
                                        to={`/property-details/${propertyItem.AutoGeneratedURL}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="ap2-preview-link-btn"
                                      >
                                        Link Preview
                                      </Link>
                                    )
                                  }
                                </div>

                              </div>
                            </td>
                            <td>
                              <button
                                type="button"
                                onClick={() => window.open(`/add-photos?id=${propertyItem.PropertyId}`, "_blank", "noopener,noreferrer")}
                                className={`ap2-table-action-btn ${propertyItem.IsPropertyImages ? "is-available" : "is-missing"}`}
                              >
                                <span className="ap2-table-action-btn__icon">
                                  <i className="fa-solid fa-image" />
                                </span>
                                <span>{propertyItem.IsPropertyImages ? "Update Images" : "Add Images"}</span>
                                <i className="icon icon-arrow-right ap2-table-action-btn__arrow" />
                              </button>
                            </td>
                            <td>
                              <button
                                type="button"
                                onClick={() => window.open(`/add-amenities?id=${propertyItem.PropertyId}`, "_blank", "noopener,noreferrer")}
                                className={`ap2-table-action-btn ${propertyItem.IsPropertyAmenities ? "is-available" : "is-missing"}`}
                              >
                                <span className="ap2-table-action-btn__icon">
                                  <i className="fa-solid fa-home" />
                                </span>
                                <span>{propertyItem.IsPropertyAmenities ? "Update Inside Facilities" : "Add Inside Facilities"}</span>
                                <i className="icon icon-arrow-right ap2-table-action-btn__arrow" />
                              </button>
                            </td>
                            <td>
                              <button
                                type="button"
                                onClick={() => window.open(`/add-near-amenities?id=${propertyItem.PropertyId}`, "_blank", "noopener,noreferrer")}
                                className={`ap2-table-action-btn ${propertyItem.IsPropertyNearAmenities ? "is-available" : "is-missing"}`}
                              >
                                <span className="ap2-table-action-btn__icon">
                                  <i className="fa-solid fa-building" />
                                </span>
                                <span>{propertyItem.IsPropertyNearAmenities ? "Update Near Facilities" : "Add Near Facilities"}</span>
                                <i className="icon icon-arrow-right ap2-table-action-btn__arrow" />
                              </button>
                            </td>
                            <td>
                              <button
                                type="button"
                                onClick={() => window.open(`/add-document?id=${propertyItem.PropertyId}`, "_blank", "noopener,noreferrer")}
                                className={`ap2-table-action-btn ${propertyItem.IsPropertyDocument ? "is-available" : "is-missing"}`}
                              >
                                <span className="ap2-table-action-btn__icon">
                                  <i className="fa-solid fa-file" />
                                </span>
                                <span>{propertyItem.IsPropertyDocument ? "Update Document" : "Add Document"}</span>
                                <i className="icon icon-arrow-right ap2-table-action-btn__arrow" />
                              </button>
                            </td>
                            <td>
                              <button
                                type="button"
                                onClick={() => window.open(`/add-floor-plan?id=${propertyItem.PropertyId}`, "_blank", "noopener,noreferrer")}
                                className={`ap2-table-action-btn ${propertyItem.IsPropertyFloor ? "is-available" : "is-missing"}`}
                              >
                                <span className="ap2-table-action-btn__icon">
                                  <i className="fa-solid fa-columns" />
                                </span>
                                <span>{propertyItem.IsPropertyFloor ? "Update Floor Plan" : "Add Floor Plan"}</span>
                                <i className="icon icon-arrow-right ap2-table-action-btn__arrow" />
                              </button>
                            </td>
                          </tr>

                        ))}
                    </tbody>
                  </table>
                </div>
                <ul className="wd-navigation">
                  <Pagination2 itemLength={myPropertiesFilter.length} itemPerPage={ItemsPerPage} setPage={setPage} />
                </ul>
              </div>
            </div>
            {/* <div className="widget-box-2 wd-chart">
              <h5 className="title">Page Inside</h5>
              <div className="wd-filter-date">
                <div className="left">
                  <div className="dates active">Day</div>
                  <div className="dates">Week</div>
                  <div className="dates">Month</div>
                  <div className="dates">Year</div>
                </div>
                <div className="right">
                  <div className="ip-group icon">
                    <input
                      type="text"
                      id="datepicker3"
                      className="ip-datepicker icon"
                      placeholder="From Date"
                    />
                  </div>
                  <div className="ip-group icon">
                    <input
                      type="text"
                      id="datepicker4"
                      className="ip-datepicker icon"
                      placeholder="To Date"
                    />
                  </div>
                </div>
              </div>
              <div className="chart-box">
                <LineChart />
              </div>
            </div> */}
          </div>
          <div className="col-xl-3">
            <div className="widget-box-2 mess-box mb-20">
              <h5 className="title">Messages</h5>
              <ul className="list-mess">
                {enquiries.length > 0 ? (
                  enquiries.slice(0, 10).map((enquiry, index) => {
                    const photoUrl = getMessagePhoto(enquiry) || avatarimg;
                    return (
                      <li className="mess-item" key={enquiry?.EnquiryId || index}>
                        <div className="user-box">
                          <div className="avatar">
                            <img
                              alt={enquiry?.Name || "Client"}
                              src={photoUrl}
                              width={51}
                              height={51}
                            />
                          </div>
                          <div className="content">
                            <div className="name fw-6">{enquiry?.Name || "Unknown"}</div>
                            <span className="caption-2 text-variant-3">
                              {getDaysAgoLabel(enquiry?.CreatedOn)}
                            </span>
                          </div>
                        </div>
                        <p>{enquiry?.Message || "No message provided."}</p>
                      </li>
                    );
                  })
                ) : (
                  <li className="mess-item">
                    <p style={{ marginBottom: 0 }}>No messages found.</p>
                  </li>
                )}
              </ul>
            </div>
            {/* <div className="widget-box-2 mess-box">
              <h5 className="title">Recent Reviews</h5>
              <ul className="list-mess">
                <li className="mess-item">
                  <div className="user-box">
                    <div className="avatar">
                      <img
                        alt="avt"
                        src="/images/avatar/avt-png13.png"
                        width={51}
                        height={51}
                      />
                    </div>
                    <div className="content">
                      <div className="name fw-6">Bessie Cooper</div>
                      <span className="caption-2 text-variant-3">
                        3 day ago
                      </span>
                    </div>
                  </div>
                  <p>
                    Maecenas eu lorem et urna accumsan vestibulum vel vitae
                    magna.
                  </p>
                  <ul className="list-star">
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                  </ul>
                </li>
                <li className="mess-item">
                  <div className="user-box">
                    <div className="avatar">
                      <img
                        alt="avt"
                        src="/images/avatar/avt-png14.png"
                        width={68}
                        height={68}
                      />
                    </div>
                    <div className="content">
                      <div className="name fw-6">Annette Black</div>
                      <span className="caption-2 text-variant-3">
                        3 day ago
                      </span>
                    </div>
                  </div>
                  <p>
                    Nullam rhoncus dolor arcu, et commodo tellus semper vitae.
                    Aenean finibus tristique lectus, ac lobortis mauris
                    venenatis ac.
                  </p>
                  <ul className="list-star">
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                  </ul>
                </li>
                <li className="mess-item">
                  <div className="user-box">
                    <div className="avatar">
                      <img
                        alt="avt"
                        src="/images/avatar/avt-png15.png"
                        width={51}
                        height={51}
                      />
                    </div>
                    <div className="content">
                      <div className="name fw-6">Ralph Edwards</div>
                      <span className="caption-2 text-variant-3">
                        3 day ago
                      </span>
                    </div>
                  </div>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Vivamus viverra semper convallis. Integer vestibulum tempus
                    tincidunt.
                  </p>
                  <ul className="list-star">
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                  </ul>
                </li>
                <li className="mess-item">
                  <div className="user-box">
                    <div className="avatar">
                      <img
                        alt="avt"
                        src="/images/avatar/avt-png16.png"
                        width={51}
                        height={51}
                      />
                    </div>
                    <div className="content">
                      <div className="name fw-6">Jerome Bell</div>
                      <span className="caption-2 text-variant-3">
                        3 day ago
                      </span>
                    </div>
                  </div>
                  <p>
                    Fusce sit amet purus eget quam eleifend hendrerit nec a
                    erat. Sed turpis neque, iaculis blandit viverra ut, dapibus
                    eget nisi.
                  </p>
                  <ul className="list-star">
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                  </ul>
                </li>
                <li className="mess-item">
                  <div className="user-box">
                    <div className="avatar">
                      <img
                        alt="avt"
                        src="/images/avatar/avt-png17.png"
                        width={51}
                        height={51}
                      />
                    </div>
                    <div className="content">
                      <div className="name fw-6">Albert Flores</div>
                      <span className="caption-2 text-variant-3">
                        3 day ago
                      </span>
                    </div>
                  </div>
                  <p>
                    Donec bibendum nibh quis nisl luctus, at aliquet ipsum
                    bibendum. Fusce at dui tincidunt nulla semper venenatis at
                    et magna. Mauris turpis lorem, ultricies vel justo sed.
                  </p>
                  <ul className="list-star">
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                    <li className="icon icon-star" />
                  </ul>
                </li>
              </ul>
            </div> */}
          </div>
        </div>
      </div>
      {/* <div className="footer-dashboard">
        <p>Copyright © 2024 Home Lengo</p>
      </div> */}
    </div>
  );
}
